import type { SVGAttributes } from 'react';

export function UpdatesAndLinksIcon(props: SVGAttributes<SVGSVGElement>) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" {...props} viewBox="0 0 32 32">
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M19.986 23.334H22c4.026 0 7.333-3.294 7.333-7.334 0-4.026-3.293-7.333-7.333-7.333h-2.014m-7.985 0h-2c-4.04 0-7.333 3.293-7.333 7.333 0 4.027 3.293 7.334 7.333 7.334h2"
			/>
			<path
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeWidth="2"
				d="M10.668 16h10.667"
				opacity=".4"
			/>
		</svg>
	);
}
